import { Assignment } from "./Assignment";
import { Class } from "./Class";

export type StudentName = {
  firstName: string;
  lastName: string;
  initials?: string;
};

export type Student = StudentName & {
  id: string;
  textPassword: string;
  class?: Class;
  assignments?: Assignment[];
  completedSessions?: number;
  upcomingSessions?: number;
};

export const getNameForConstruct = ({ firstName, lastName }: StudentName): string => {
  return `${firstName} ${lastName.length ? lastName[0].toUpperCase() : ""}`;
};
